import { compose } from 'redux';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { injectIntl } from 'react-intl';
import { format } from 'date-fns';
import _merge from 'lodash/merge';
import { selectActiveVenueId, selectVenueClasses } from 'selectors/general';
import { withForm } from 'components/Form';
import { premiumCapModalResponse, deletePremiumCapRule as deletePremiumCapRuleAction } from '../PremiumCaps.saga';
import PremiumCapsRuleModal from './PremiumCapsRuleModal';
import { syncValidator, submitValidator } from './PremiumCapsRuleModal.validators';

const FORM_NAME = 'edit-premium-cap-modal';

const mapStateToProps = (state, ownProps) => {
  const classes = selectVenueClasses(state) || [];
  const { rule } = ownProps;
  const { id, recurrence: { dateStart, dateEnd } = {} } = rule;
  const today = format(new Date(), 'yyyy-MM-dd');
  const initialValues = _merge(
    {
      recurrence: {
        dateStart: dateStart || today,
        dateEnd: dateEnd || dateStart || today,
        daysOfWeek: [],
        timeOfDayStart: '00:00:00',
        timeOfDayEnd: '23:45:00',
      },
      entityMetadata: {},
      displayData: {},
    },
    rule
  );
  const currentValues = getFormValues(FORM_NAME)(state) || initialValues;

  return {
    classes,
    isEditModal: true,
    initialValues,
    currentValues,
    venueId: selectActiveVenueId(state),
    ruleId: id,
  };
};

const mapDispatchToProps = {
  onSubmit: premiumCapModalResponse,
  deletePremiumCapRule: deletePremiumCapRuleAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { venueId, ruleId, ...restStateProps } = stateProps;
  const { deletePremiumCapRule, ...restDispatchProps } = dispatchProps;

  return {
    ...restStateProps,
    ...restDispatchProps,
    deletePremiumCapRule: deletePremiumCapRule.bind(null, venueId, ruleId),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withForm({
    name: FORM_NAME,
    syncValidator,
    submitValidator,
  }),
  injectIntl
)(PremiumCapsRuleModal);
